import { memo } from 'react';

import EmailFilledIconSVG from '@/assets/email-filled-icon.svg?react';
import { ComponentContextProps, merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type EmailFilledLogoProps = LogoProps & Partial<ComponentContextProps>;

const IEmailFilledLogo = ({ variant, className, ...rest }: EmailFilledLogoProps) => {
  return (
    <Logo variant={variant} className={merge('', className)} {...rest}>
      <EmailFilledIconSVG />
    </Logo>
  );
};

export const EmailFilledLogo = memo(IEmailFilledLogo) as typeof IEmailFilledLogo;
